import { getKitchenCalls, postKitchenCalls } from '@agos/api-client/orders'

/**
 * The two calls of `BACKEND.md` §10A.369, through the generated client since the merge regenerated it.
 *
 * <p>The answers are still parsed by `kitchen-calls.ts`'s own readers (`kitchenCallsOf`), which drop a row the screen
 * could not announce; these two only say which request goes out.
 */

/** `POST /kitchen/calls` - a call about one ticket, or the general bell when `orderId` is null. */
export async function postKitchenCall(orderId: number | null): Promise<unknown> {
  return postKitchenCalls({ orderId })
}

/** `GET /kitchen/calls` from a mark - see `kitchenCallsParams`. */
export async function readKitchenCalls(params?: { afterId: number }): Promise<unknown> {
  return getKitchenCalls(params)
}
